import React, { Component, Fragment } from "react";
import moment from "moment";

import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Creators as ReportsActions } from "store/ducks/reports";

import { Access, NumberFormat } from "common";
import { Page, Breadcrumbs, Panel, Loading } from "components";
import { Filters } from "./components";

const FILTER_DEFAULT_VALUES = {
  region: null,
  date_start: null,
  date_end: null,
  date_formatted: "",
  stores_formatted: "Todas",
};

class Benefits extends Component {
  state = {
    breadcrumbs: [
      { name: "Home", to: "/" },
      { name: "Relatórios", to: "/reports" },
      { name: "Relatório Geral do Programa de Fidelidade", to: "" },
    ],
    filter: {
      ...FILTER_DEFAULT_VALUES,
      stores: Access.lockedStore() ? [Access.lockedStore(true)] : [],
    },
  };

  componentDidMount() {
    const { getReportGeneralRequest } = this.props;

    getReportGeneralRequest(this.state.filter);
  }

  componentDidUpdate(oldProps, oldState) {
    const { filter } = this.state;

    if (
      oldState.filter.date_start !== filter.date_start ||
      oldState.filter.date_end !== filter.date_end
    ) {
      const date_formatted = filter.date_start
        ? `${
            filter.date_start !== null
              ? moment(filter.date_start).format("DD/MM/YYYY")
              : ""
          } ${filter.date_end !== null ? "-" : ""} ${
            filter.date_end !== null
              ? moment(filter.date_end).format("DD/MM/YYYY")
              : ""
          }`
        : "";

      this.setState({ filter: { ...filter, date_formatted } });
    }

    if (oldState.filter.stores !== filter.stores) {
      const stores_formatted = filter.stores
        .map((store) => store.label)
        .join(", ");

      this.setState({ filter: { ...filter, stores_formatted } });
    }
  }

  handleChangeFilter = async (name, value) => {
    const { filter } = this.state;
    const { getReportGeneralRequest } = this.props;

    const newState = { filter: { ...filter, [name]: value } };

    if (name === "region") {
      newState.filter.stores = [];
      newState.filter.stores_formatted = "";
    }

    this.setState(newState, () => {
      getReportGeneralRequest(this.state.filter);
    });
  };

  handleCleanFilter = async (e) => {
    e.preventDefault();

    const { getReportGeneralRequest } = this.props;

    const newState = {
      filter: {
        ...FILTER_DEFAULT_VALUES,
        stores: Access.lockedStore() ? [Access.lockedStore(true)] : [],
      },
    };

    this.setState(newState, () => {
      getReportGeneralRequest(this.state.filter);
    });
  };

  handleExport = (e) => {
    e.preventDefault();

    const { filter } = this.state;
    const { exportReportGeneralRequest } = this.props;

    exportReportGeneralRequest(filter);
  };

  render() {
    const { breadcrumbs, filter } = this.state;
    const { report } = this.props;

    return (
      <Page className="page-reports">
        <Breadcrumbs breadcrumbs={breadcrumbs} />

        <header className="page-reports-header">
          <Page.Title>Relatório Geral do Programa de Fidelidade</Page.Title>

          <Filters
            data={filter}
            onChange={this.handleChangeFilter}
            onClean={this.handleCleanFilter}
          />
        </header>

        <Panel className="panel-list">
          <Fragment>
            {report.loading && <Loading type="table" size="x-large" />}

            {filter.date_formatted !== "" && (
              <Panel.Title>
                Período: <span>{filter.date_formatted}</span>
              </Panel.Title>
            )}

            {filter.stores_formatted !== "" && (
              <Panel.Title>
                Lojas: <span>{filter.stores_formatted}</span>
              </Panel.Title>
            )}

            <h5>Cadastros</h5>

            {!report.loading && (
              <Fragment>
                <table className="contact-table table table-curved table-striped">
                  <thead>
                    <tr>
                      <th>Total de clientes</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>MEMBROS CADASTRADOS</td>
                      <td className="number-report">
                        {NumberFormat(
                          report.data.registrations.plans_data.registered,
                          0,
                          ",",
                          "."
                        )}
                      </td>
                    </tr>
                    <tr>
                      <td>CLIENTE FINAL ATIVO</td>
                      <td className="number-report">
                        {NumberFormat(
                          report.data.registrations.plans_data.code_1,
                          0,
                          ",",
                          "."
                        )}
                      </td>
                    </tr>
                    <tr>
                      <td>LEAD/CADASTRADOS</td>
                      <td className="number-report">
                        {NumberFormat(
                          report.data.registrations.plans_data.code_2,
                          0,
                          ",",
                          "."
                        )}
                      </td>
                    </tr>
                    <tr>
                      <td>LEAD/PDV</td>
                      <td className="number-report">
                        {NumberFormat(
                          report.data.registrations.leadsByRegistrationSource?.totalPDV ?? 0,
                          0,
                          ",",
                          "."
                        ) || 0}
                      </td>
                    </tr>
                    <tr>
                      <td>CLIENTE FINAL REMOVIDO</td>
                      <td className="number-report">
                        {NumberFormat(
                          report.data.registrations.plans_data.code_3,
                          0,
                          ",",
                          "."
                        )}
                      </td>
                    </tr>
                    <tr>
                      <td>PRO/EXECUTOR ATIVO</td>
                      <td className="number-report">
                        {NumberFormat(
                          report.data.registrations.plans_data.code_4,
                          0,
                          ",",
                          "."
                        )}
                      </td>
                    </tr>
                    <tr>
                      <td>PRO/EXECUTOR REMOVIDO</td>
                      <td className="number-report">
                        {NumberFormat(
                          report.data.registrations.plans_data.code_6,
                          0,
                          ",",
                          "."
                        )}
                      </td>
                    </tr>
                    <tr>
                      <td>PRO/EADs ATIVOS COM DOCUMENTAÇÃO</td>
                      <td className="number-report">
                        {NumberFormat(
                          report.data.registrations.plans_data.code_7,
                          0,
                          ",",
                          "."
                        )}
                      </td>
                    </tr>
                    <tr>
                      <td>PRO/EADs ATIVOS DOCUMENTO EM VALIDAÇÃO</td>
                      <td className="number-report">
                        {NumberFormat(
                          report.data.registrations.plans_data.code_8,
                          0,
                          ",",
                          "."
                        )}
                      </td>
                    </tr>
                    <tr>
                      <td>PRO/EADs REMOVIDOS</td>
                      <td className="number-report">
                        {NumberFormat(
                          report.data.registrations.plans_data.code_9,
                          0,
                          ",",
                          "."
                        )}
                      </td>
                    </tr>
                    <tr>
                      <td>PRO/EADs ATIVOS SEM DOCUMENTAÇÃO</td>
                      <td className="number-report">
                        {NumberFormat(
                          report.data.registrations.plans_data.code_10,
                          0,
                          ",",
                          "."
                        )}
                      </td>
                    </tr>
                    <tr>
                      <td>PRO/EADs ATIVOS DOCUMENTAÇÃO NEGADA</td>
                      <td className="number-report">
                        {NumberFormat(
                          report.data.registrations.plans_data.code_11,
                          0,
                          ",",
                          "."
                        )}
                      </td>
                    </tr>
                    <tr>
                      <td>TOTAL EAD</td>
                      <td className="number-report">
                        {NumberFormat(
                          report.data.registrations.plans_data.total_ead,
                          0,
                          ",",
                          "."
                        )}
                      </td>
                    </tr>
                  </tbody>

                  <thead>
                    <tr>
                      <th>Origem do cadastro</th>
                      <th />
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Loja</td>
                      <td className="number-report">
                        {NumberFormat(
                          report.data.registrations.store,
                          0,
                          ",",
                          "."
                        )}
                      </td>
                    </tr>
                    <tr>
                      <td>Site</td>
                      <td className="number-report">
                        {NumberFormat(
                          report.data.registrations.site,
                          0,
                          ",",
                          "."
                        )}
                      </td>
                    </tr>
                    {report.data.registrations.leadsByRegistrationSource?.leadsBySource.map(
                      (leadRegistrationChannel, index) => (
                        <tr key={index}>
                          <td>Lead/{leadRegistrationChannel.source}</td>
                          <td className="number-report">
                            {NumberFormat(
                              leadRegistrationChannel.total,
                              0,
                              ",",
                              "."
                            ) || 0}
                          </td>
                        </tr>
                    ))}
                  </tbody>

                  <thead>
                    <tr>
                      <th>Profissões</th>
                      <th />
                    </tr>
                  </thead>
                  <tbody>
                    {report.data.registrations.jobs_data.map((job) => (
                      <tr key={job.job}>
                        <td>{job.job}</td>
                        <td className="number-report">
                          {NumberFormat(job.total, 0, ",", ".")}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </Fragment>
            )}

            <button className="button-submit" onClick={this.handleExport}>
              Exportar Planilha
            </button>
          </Fragment>
        </Panel>
      </Page>
    );
  }
}

const mapState = (state) => ({
  report: {
    ...state.reports.general,
    data: state.reports.general.data,
  },
});

const mapActions = (dispatch) => bindActionCreators(ReportsActions, dispatch);

export default connect(mapState, mapActions)(Benefits);
